import DocumentTypeLabelForStupidInconsistency from './DocumentTypeLabelForStupidInconsistency'

export default DocumentTypeLabelForStupidInconsistency
